export default function (data, name) {
  const blob = new Blob([data], {
    type: 'application/octet-stream;charset=utf-8'
  });
  const downloadElement = document.createElement('a');
  const href = window.URL.createObjectURL(blob);

  downloadElement.href = href;
  downloadElement.download = name;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement); // 下载後移除元素
  window.URL.revokeObjectURL(href); // 釋放掉blob对象
}
